export const canManageVideos = () => Rails.abilities?.manageVideos === true;
